<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>
import { SALES_PLAN_STATUS_FILTER_OPTIONS } from "@/utils/salesPlanFilters";

export default {
  name: "sales-plan-status-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        {
          value: null,
          text: this.placeholder
            ? this.placeholder
            : this.$t("Please select {something}", { something: this.$t("sales_plans.status") })
        },
        ...SALES_PLAN_STATUS_FILTER_OPTIONS.map((option) => ({
          value: option.value,
          text: this.lodash.startCase(this.$t(option.labelKey))
        }))
      ]
    };
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit("input", val);
      }
    },
    value(val) {
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit("input", event);
    },
    clearAll() {
      this.$emit("input", undefined);
    }
  }
};
</script>

<style scoped>
</style>
